import consumer from './consumer';

document.addEventListener('DOMContentLoaded', () => {
  const byId = (id) => document.getElementById(id);
  const selectAll = (selector, root = document) => Array.from(root.querySelectorAll(selector));

  // This function is executed after 3mn if Doclift does not answer
  function docliftDoesNotAnswer() {
    if (!(typeof iframe == 'object')) {
      consumer.disconnect();
      byId('subscriptionStep2')?.classList.add('d-none');
      byId('subscriptionStep3')?.classList.add('d-none');
      byId('subscriptionStep4')?.classList.add('d-none');
      byId('subscriptionStepError')?.classList.remove('d-none');
    }
  }

  function generateUniversignIframe(signerId) {
    const configuration = {};
    const iframeEndpoint = byId('subscriptionStep3')?.dataset?.universignIframeEndpoint;
    /**
     * The universignSigInit function add an iframe element as child of element with
     * id attribute equals to containerId parameter, the attribute src is set from
     * the universignUrl variable, it is the url of the website to be integrated in
     * the iframe, the width and height of the iframe will take 100% of its
     * container.
     *
     * @param {string} containerId The id of the element in which we will inject
     * the iframe.
     * @param {string} signerId The identifier of transaction.
     * @param {object} configuration The options list to customize the iframe:
     * * redirectionMode {string} This params have two possible values: IN or OUT,
     * the dafault value is OUT,
     * if the value of this params is equal to OUT the redirection will be done
     * outside the iframe(in website container of the iframe),
     * if the value of this params is equal to ÌN the redirection will be done
     * inside the iframe,
     * if the value of this params is otherwise, an exception will be triggered.
     **/

    universignSigInit('subscriptionStep3', signerId, configuration, iframeEndpoint);
  }

  function generateContractIframe(documentUrl) {
    iframe = document.createElement('iframe');
    iframe.style.width = '100%';
    iframe.style.height = '86%';
    iframe.src = documentUrl;

    byId('subscriptionStep3')?.prepend(iframe);

    selectAll('.edit_subscription').forEach((el) => {
      el.addEventListener('ajax:success', (_event) => {
        byId('subscriptionStep3')?.classList.add('d-none');
        byId('subscriptionStep4')?.classList.remove('d-none');

        const breadcrumb3 = document.querySelector('.breadcrumb-element:nth-child(3)');
        breadcrumb3?.classList.remove('current');
        breadcrumb3?.classList.add('past');

        const breadcrumb4 = document.querySelector('.breadcrumb-element:nth-child(4)');
        breadcrumb4?.classList.remove('next');
        breadcrumb4?.classList.add('current');

        const currentStep = byId('current_step');
        if (currentStep) currentStep.textContent = '4';
      });
    });
  }

  let iframe;

  let docliftDoesNotAnswerTimer = setTimeout(docliftDoesNotAnswer, 180000);

  const signatureSubscriptionEl = byId('signature-subscription-id');
  if (!signatureSubscriptionEl) {
    return;
  }

  consumer.subscriptions.create(
    { channel: 'SignatureChannel', subscription_id: signatureSubscriptionEl.dataset.id },
    {
      received(data) {
        try {
          if (data.status == 'success') {
            clearTimeout(docliftDoesNotAnswerTimer);

            if (data.e_sign_id !== undefined) {
              generateUniversignIframe(data.e_sign_id);
            } else {
              generateContractIframe(data.document_url);
            }

            // Enable the button to load the contract and display the success message
            const contractLoadedButton = byId('contractLoadedButton');
            if (contractLoadedButton) contractLoadedButton.disabled = false;

            const subscriptionStep2 = byId('subscriptionStep2');
            const stepTitle = byId('step-title');
            if (subscriptionStep2 && stepTitle) {
              stepTitle.textContent = subscriptionStep2.dataset.titleInCaseOfDocReady;
            }

            selectAll('#subscriptionStep2 [data-image-before-doc-ready]').forEach((el) => el.classList.add('d-none'));
            selectAll('#subscriptionStep2 [data-image-in-case-of-doc-ready]').forEach((el) => {
              el.classList.add('d-flex');
              el.classList.remove('d-none');
            });
            byId('generatingDocInProgressExplanations')?.classList.add('d-none');
            byId('generatingDocReadyExplanations')?.classList.remove('d-none');

            contractLoadedButton?.addEventListener('click', (_e) => {
              byId('subscriptionStep3')?.classList.remove('d-none');
              byId('subscriptionStep2')?.classList.add('d-none');

              const breadcrumb2 = document.querySelector('.breadcrumb-element:nth-child(2)');
              breadcrumb2?.classList.remove('current');
              breadcrumb2?.classList.add('past');

              const breadcrumb3 = document.querySelector('.breadcrumb-element:nth-child(3)');
              breadcrumb3?.classList.remove('next');
              breadcrumb3?.classList.add('current');

              const currentStep = byId('current_step');
              if (currentStep) currentStep.textContent = '3';
            });
          } else {
            setTimeout(() => {
              byId('subscriptionStep2')?.classList.add('d-none');
              byId('subscriptionStep3')?.classList.add('d-none');
              byId('subscriptionStep4')?.classList.add('d-none');
              byId('subscriptionStepError')?.classList.remove('d-none');
            }, 5000);
          }
        } catch {
          setTimeout(() => {
            byId('subscriptionStep2')?.classList.add('d-none');
            byId('subscriptionStep3')?.classList.add('d-none');
            byId('subscriptionStep4')?.classList.add('d-none');
            byId('subscriptionStepError')?.classList.remove('d-none');
          }, 5000);
        }
      },
      rejected() {
        setTimeout(() => {
          byId('subscriptionStep2')?.classList.add('d-none');
          byId('subscriptionStep3')?.classList.add('d-none');
          byId('subscriptionStep4')?.classList.add('d-none');
          byId('subscriptionStepError')?.classList.remove('d-none');
        }, 5000);
        this.uninstall();
      },
    },
  );
});
